export default __webpack_public_path__ + "static/media/img18.b22d8833.PNG";